export enum SignMailRecordingStatus {
  NOT_STARTED = 'NOT_STARTED',
  RECORDING = 'RECORDING',
  UPLOADING = 'UPLOADING',
  UPLOAD_COMPLETE = 'DONE',
  MAIL_BOX_FULL = 'MAIL_BOX_FULL',
  ERROR_OCCURRED = 'ERROR_OCCURRED',
}
